var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"loadBar",staticClass:"g_loadBar"},[_c('div',{staticClass:"_inner",style:({width: (_vm.perc + "%")})}),_c('loadShimmer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }